import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="w-full bg-cream" data-id="element-118" data-mp="1o3x1pk7r0m0y">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-119" data-mp="1o5zvmfc0uzay">
        <div className="rounded-3xl bg-sage-tint border border-sage-soft p-8 sm:p-12 text-center" data-id="element-120" data-mp="222n2paxov5ul">
          <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white border border-sage-soft" data-id="element-121" data-mp="1x54pv9gjw6hb">
            <ShieldCheckIcon className="w-8 h-8 text-sage" aria-hidden="true" data-id="element-122" data-mp="19cek5hz8qjfh" />
          </span>
          <h2 id="guarantee-heading" className="mt-6 font-serif font-bold text-ink text-xl sm:text-3xl leading-snug" data-id="element-123" data-mp="14dtg17gvbflr">
            Garanzia di 7 giorni
          </h2>
          <p className="mt-5 font-serif italic text-lg sm:text-2xl text-sage max-w-xl mx-auto leading-snug" data-id="element-124" data-mp="1ec0wzqb5pxnr">
            Scaricalo. Apri i sei volumi. Usa una scheda con un cliente vero.
          </p>
          <p className="mt-5 text-ink-soft text-base leading-relaxed max-w-xl mx-auto" data-id="element-125" data-mp="ozjbwl3tncpo">
            Se entro 7 giorni non è quello che ti aspettavi, ti rimborsiamo il
            100%. Nessun modulo, nessuna trafila, nessun risentimento.
          </p>
        </div>
      </div>
    </section>;
}